import React, { useState, useEffect } from 'react';
import OurLibrary from './OurLibrary';
import ScheduleViewer from './ScheduleViewer';


function PublicStoryLibrary({ stories,onSecretTrigger, onOpenOur }) {
    const [gallery, setGallery] = useState([]);
  
  const [modalStory, setModalStory] = useState(null);
  const [showOur, setShowOur] = useState(false);
  const [showSchedules, setShowSchedules] = useState(false);
  const [ourAllowUpload, setOurAllowUpload] = useState(false);

  useEffect(() => {
    console.log('PublicStoryLibrary mounted. onOpenOur present:', typeof onOpenOur === 'function');
  }, [onOpenOur]);

  // const handleOpenOur = () => {
  //   console.log('Public OurLibrary button clicked, onOpenOur:', typeof onOpenOur);
  //   if (typeof onOpenOur === 'function') {
  //     onOpenOur();
  //     return;
  //   }
  //   // fallback: dispatch global event so parent can listen if prop not provided
  //   window.dispatchEvent(new CustomEvent('openOurLibrary', { detail: { allowUpload: false } }));
  // };

  useEffect(() => {
          fetch('https://storypublisher.onrender.com/gallery')
              .then(res => res.json())
              .then(data => setGallery(data));
  
          const handler = (e) => {
            console.log('MainPage received openOurLibrary event, detail:', e.detail);
            const allow = e.detail && e.detail.allowUpload === true;
            setOurAllowUpload(allow);
            setShowOur(true);
          };
          window.addEventListener('openOurLibrary', handler);
          return () => window.removeEventListener('openOurLibrary', handler);
  
      }, []);

  const addToGallery = async (newPhoto) => {
        // If story already looks saved by the server (has _id or id), just prepend it and avoid re-posting
        if (newPhoto && (newPhoto._id || newPhoto.id)) {
            setGallery(prev => [newPhoto, ...prev]);
            return;
        }
        const res = await fetch('https://storypublisher.onrender.com/gallery', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newPhoto)
        });
        const savedPhoto = await res.json();
        setGallery(prev => [savedPhoto, ...prev]);
    };

  return (
    <div className="library">
      {!showOur && !showSchedules ? (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1><b><span
              style={{ userSelect: 'none', cursor: 'pointer' }}
              onDoubleClick={onSecretTrigger}
            >
              H
            </span>er&nbsp;Library</b></h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { setOurAllowUpload(false); setShowOur(true); }}>Our Gallery</button>
          <button onClick={() => setShowSchedules(true)}>📅 Schedules</button>
        </div>
      </div>) : showSchedules ? (
        <>
          <div className="button-group">
            <button onClick={() => setShowSchedules(false)}>← Back to Stories</button>
          </div>
          <ScheduleViewer />
        </>
      ) : (
        <>
          <div className="button-group">
            <button onClick={() => setShowOur(false)}>Back</button>
          </div>
          <OurLibrary stories={gallery} addStory={addToGallery} allowUpload={ourAllowUpload} />
        </>
      )}
      {stories.length === 0 && !showOur && !showSchedules ? (
        <p>No stories published yet.</p>
      ) : !showOur && !showSchedules ? (
        stories.map((story) => {
          const imgSrc = story.imagePath ? (story.imagePath.startsWith('http') ? story.imagePath.replace(/^http:/, 'https:') : story.imagePath) : null;
          return (
            <div key={story._id || story.id} className="story-card">
              <h3 onClick={() => setModalStory(story)} style={{ cursor: 'pointer' }}>{story.title}</h3>
              <p><em>{new Date(story.createdAt).toLocaleDateString()}</em></p>
              {imgSrc && (
                <img src={imgSrc} alt={story.title}  />
              )}
              <p>{story.content ? story.content.slice(0, 1000) : ''}{story.content && story.content.length > 1000 ? '...' : ''}</p>
            </div>
          );
        })
      ) : ''}
      {modalStory && !showOur && !showSchedules && (
        <div className="modal-overlay" onClick={() => setModalStory(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{modalStory.title}</h2>
            <p><em>{new Date(modalStory.createdAt).toLocaleDateString()}</em></p>
            {modalStory.imagePath && (
              <img src={modalStory.imagePath.startsWith('http') ? modalStory.imagePath.replace(/^http:/, 'https:') : modalStory.imagePath} alt={modalStory.title}  />
            )}
            <p className="story-text">{modalStory.content}</p>
            <button onClick={() => setModalStory(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PublicStoryLibrary;
